import { GLOBAL_USERS_COLLECTION } from "wombat-global/src/constants";
import type { IGlobalUserEntity } from "wombat-global/src/typings";

import { useAuthenticationContext } from "../contexts/authentication/authentication.context";
import { useDocSnap } from "./useSubscription.v2";

export function useCurrentUserAccess() {
  const { uid, isAuthenticated } = useAuthenticationContext();
  const [globalUser, status] = useDocSnap<IGlobalUserEntity>(
    `${GLOBAL_USERS_COLLECTION}/${uid}`,
    { enabled: isAuthenticated && Boolean(uid) },
  );
  const resolved = isAuthenticated && Boolean(uid) && status === "success";
  const hasAccess =
    resolved && Object.keys(globalUser?.access || {}).length > 0;

  return { globalUser, hasAccess, hasNoAccess: resolved && !hasAccess, status };
}
